/* =========================================================================
   paws by Ciroa, sticky bundle tracker.

   Mirrors the bundle builder's state into a fixed bar at the bottom of the
   screen, so picks and the next discount tier stay visible while scrolling.

   It reads the builder rather than owning state, so the two cannot disagree.
   Picks come from the cards: any .paws-bcard carrying is-on, quantity from its
   badge, matched to window.PAWS_BUNDLE_PRODUCTS by the card's data-i. That is
   what gives thumbnails, which a list of names could not.

   THE CONTAINER IS #paws-groups, not #paws-bgrid. paws-bgrid is a class on each
   category grid inside it, and there is no element with that id. Getting this
   wrong made the whole bar disappear silently, because init returned early.
   ========================================================================= */
(function () {
  'use strict';

  function init() {
    var grid = document.getElementById('paws-groups')
            || document.querySelector('.paws-bgrid')
            || null;
    var countEl = document.getElementById('paws-bcount');
    var totalEl = document.getElementById('paws-btotal');
    var nudgeEl = document.getElementById('paws-bnudge');
    var fillEl = document.getElementById('paws-unlock-fill');
    var cta = document.getElementById('paws-bcta');
    if (!grid || !countEl || !cta) return;

    var P = window.PAWS_BUNDLE_PRODUCTS || [];

    var bar = document.createElement('div');
    bar.className = 'paws-track';
    bar.innerHTML =
      '<span class="paws-track__mid">' +
        '<span class="paws-track__top">' +
          '<span class="paws-track__n" data-n>0</span>' +
          '<span class="paws-track__nudge" data-nudge></span>' +
        '</span>' +
        '<span class="paws-track__bar"><span class="paws-track__fill" data-fill></span></span>' +
        '<span class="paws-track__chips" data-chips></span>' +
      '</span>' +
      '<span class="paws-track__tot" data-tot></span>' +
      '<button type="button" class="paws-track__go" data-go>Finish</button>';
    document.body.appendChild(bar);

    var nEl = bar.querySelector('[data-n]');
    var nudge = bar.querySelector('[data-nudge]');
    var fill = bar.querySelector('[data-fill]');
    var chips = bar.querySelector('[data-chips]');
    var tot = bar.querySelector('[data-tot]');

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /* Finish scrolls to the real button and clicks it, so there is one code
       path for adding to cart or registering interest. */
    bar.querySelector('[data-go]').addEventListener('click', function () {
      cta.scrollIntoView({ block: 'center' });
      setTimeout(function () { cta.click(); }, 260);
    });

    function sync() {
      var num = parseInt((countEl.textContent || '').trim(), 10);
      if (isNaN(num)) num = 0;

      nEl.textContent = num;
      nudge.textContent = (nudgeEl && nudgeEl.textContent.trim()) || '';
      tot.textContent = (totalEl && totalEl.textContent.trim()) || '';
      fill.style.width = (fillEl && fillEl.style.width) || '0%';

      var picked = [].slice.call(grid.querySelectorAll('.paws-bcard.is-on'));
      chips.innerHTML = picked.map(function (card) {
        var p = P[Number(card.getAttribute('data-i'))] || {};
        var badge = card.querySelector('[data-qty]');
        var q = badge ? parseInt(badge.textContent, 10) : 1;
        if (isNaN(q) || q < 1) q = 1;
        var img = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.n || '') + '">' : '';
        return '<span class="paws-track__chip" title="' + esc(p.n || '') + '">' + img +
          (q > 1 ? '<b>' + q + '</b>' : '') + '</span>';
      }).join('');

      var on = num > 0;
      bar.classList.toggle('is-live', on);
      document.body.classList.toggle('paws-has-track', on);
    }

    new MutationObserver(sync).observe(grid, { subtree: true, attributes: true, childList: true, characterData: true });
    new MutationObserver(sync).observe(countEl, { childList: true, characterData: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();